<div class="list-page tiimikokonaisuudet-page">
  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div class="debug-urit">
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 0.5em; padding-left: 1em; padding-right: 1em">
        Tiimit: <a [href]="tiimitEncodedUriObservable | async" target="_BLANK">{{ tiimitUriObservable | async }}</a>
      </div>
    </div>
  }

  <div class="tiimit-grid">
    <div class="tiimit-lista mat-elevation-z1">
      <div class="lista-otsikko-rivi">
        <span class="lista-otsikko">Tiimikokonaisuudet</span>
        <app-icon-button (click)="lisaaUusiKokonaisuus()" actionId="Lisää uusi tiimikokonaisuus" matIcon="add" matTooltip="Lisää uusi tiimikokonaisuus"></app-icon-button>
      </div>
      @if (lataa()) {
        <div lemon-loading [show]="true"></div>
      } @else {
        @for (rivi of kokonaisuudet(); track rivi.avain) {
          <div class="tiimi-rivi" [class.valittu]="rivi.avain === valittuAvain" (click)="valitseKokonaisuus(rivi)">
            <span class="tiimi-nimi">{{ rivi.nimi }}</span>
            <span class="tiimi-jasenmaara">{{ rivi.aktiivisetTiimit }}</span>
          </div>
        }
        @if (kokonaisuudet().length === 0) {
          <div class="tyhja">Ei tiimikokonaisuuksia. Luo ensimmäinen plus-napista.</div>
        }
      }
    </div>

    <div class="tiimi-detail mat-elevation-z1">
      @if (valittunKokonaisuusNakymaObservable | async; as nakyma) {
        <div class="detail-otsikko">
          <span class="tiimi-detail-nimi">{{ nakyma.kokonaisuus.nimi }}</span>
          <app-icon-button (click)="muokkaaKokonaisuutta(nakyma.kokonaisuus)" actionId="Muokkaa tiimikokonaisuutta" matIcon="edit" matTooltip="Muokkaa nimeä ja voimassaoloa"></app-icon-button>
          <span class="tiimi-detail-meta">
            @if (nakyma.kokonaisuus.alku && nakyma.kokonaisuus.alku !== 100101) {
              {{ nakyma.kokonaisuus.alku | lnumberpvm | async }}
            } @else {
              ei tiedossa
            }
            -
            @if (nakyma.kokonaisuus.loppu) {
              {{ nakyma.kokonaisuus.loppu | lnumberpvm | async }}
            } @else {
              <em>jatkuu</em>
            }
          </span>
          <span class="tiimi-detail-meta avain-meta">Avain: {{ nakyma.kokonaisuus.avain }}</span>
        </div>

        <div class="osio">
          <div class="osio-otsikko">
            <span>Tiimit kokonaisuudessa ({{ nakyma.tiimirivit.length }})</span>
            <app-secondary-button (click)="lisaaTiimiKokonaisuuteen(nakyma)" actionId="Lisää tiimi kokonaisuuteen" matIcon="add">Lisää tiimi</app-secondary-button>
          </div>
          @if (nakyma.tiimirivit.length === 0) {
            <div class="tyhja">Ei tiimejä kokonaisuudessa.</div>
          }
          @for (rivi of nakyma.tiimirivit; track rivi.tiimiAvain + '-' + rivi.alku) {
            <div class="jasen-rivi" [class.paattynyt]="!rivi.aktiivinen">
              <span class="jasen-nimi">{{ rivi.tiimiNimi }}</span>
              <span class="jasen-jakso">
                {{ rivi.alku | lnumberpvm | async }} -
                @if (rivi.loppu) {
                  {{ rivi.loppu | lnumberpvm | async }}
                } @else {
                  <em>jatkuu</em>
                }
              </span>
              <app-icon-button (click)="muokkaaTiiminJaksoa(nakyma, rivi)" actionId="Muokkaa kokonaisuuden tiimijaksoa" matIcon="edit" matTooltip="Muokkaa jaksoa"></app-icon-button>
            </div>
          }
        </div>

        <div class="info-kohta">
          Esihenkilöiden hallinta on tehtävissä <a routerLink="/yllapito/tiimit">tiimien hallintanäkymässä</a>.
        </div>
      } @else if (!lataa()) {
        <div class="tyhja-detail">Valitse tiimikokonaisuus vasemmalta tai luo uusi.</div>
      }
    </div>
  </div>
</div>
